import { fetcher, creator, patcher, remover } from '@helpers/httpMethods'

interface Read {
  url: string
  params?: Object
}

interface AuthRead extends Read {
  token: string
}

interface Write {
  url: string
  params?: Object
  body?: Object
}

interface AuthWrite extends Write {
  token: string
}

const publicFetch = ({ url, params }: Read) =>
  fetcher({
    url: `${process.env.NEXT_PUBLIC_STRAPI_URL}${url}`,
    params
  })

const publicPatch = ({ url, params, body }: Write) =>
  patcher({
    url: `${process.env.NEXT_PUBLIC_STRAPI_URL}${url}`,
    params,
    body
  })

const publicCreate = ({ url, params, body }: Write) =>
  creator({
    url: `${process.env.NEXT_PUBLIC_STRAPI_URL}${url}`,
    params,
    body
  })

const publicRemove = ({ url, body }: Write) =>
  remover({
    url: `${process.env.NEXT_PUBLIC_STRAPI_URL}${url}`,
    body
  })

const authFetch = ({ url, params, token }: AuthRead) =>
  fetcher({
    url: `${process.env.NEXT_PUBLIC_STRAPI_URL}${url}`,
    params,
    headers: { Authorization: `Bearer ${token}` }
  })

const authCreate = ({ url, params, body, token }: AuthWrite) =>
  creator({
    url: `${process.env.NEXT_PUBLIC_STRAPI_URL}${url}`,
    params,
    body,
    headers: { Authorization: `Bearer ${token}` }
  })

const authModify = ({ url, params, body, token }: AuthWrite) =>
  patcher({
    url: `${process.env.NEXT_PUBLIC_STRAPI_URL}${url}`,
    params,
    body,
    headers: { Authorization: `Bearer ${token}` }
  })

export {
  publicFetch,
  publicCreate,
  publicPatch,
  publicRemove,
  authFetch,
  authCreate,
  authModify
}
